export default __webpack_public_path__ + "static/media/etherthirst.00cb7288.png";